/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Crashboxx Icon component.
 */
export const SideNavCrashboxxIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_16019_9407)'>
        <circle cx='9.81854' cy='18.1872' r='2.06805' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M1.00008 4.71387H3.62558C4.17787 4.71387 4.62558 5.16158 4.62558 5.71387V18.1772H1' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M4.62646 7.08691L10.0999 7.08691C10.4215 7.08691 10.7236 7.24164 10.9115 7.50271L14.6993 12.7649C14.8218 12.9351 14.8877 13.1394 14.8877 13.3491V18.1744H12.2251M4.62646 18.1744H7.15557' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M15.0243 6.92822L17.0606 4.33237L17.9243 6.94204L21.2691 6.28049L19.9918 9.48742L23.4652 11.2334L19.9183 12.63L20.782 15.2397L17.8415 14.431' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_16019_9407'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideNavCrashboxxIcon;
